import React, { useEffect, useRef, useState } from 'react';
// import logoIcon from './taron-logo.png'; // Use your actual image path or URL

const RestaurantMap = () => {
  const mapRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);

  const locations = [
    { name: "Pablito's Chicken Van Nuys", lat: 34.20136, lng: -118.4522149, url: "/vannuys" },
    // { name: "Taron North Hollywood", lat: 34.187, lng: -118.3813, url: "/locations/north-hollywood" },
    // { name: "Taron Pasadena", lat: 34.1478, lng: -118.1445, url: "/locations/pasadena" },
  ];

  useEffect(() => {
    const handleGoogleMapsReady = () => {
      console.log('✅ google-maps-ready event received');
      setMapReady(true);
    };

    // ✅ Catch if Google Maps is already available before this component mounted
    if (window.google?.maps) {
      handleGoogleMapsReady();
    } else {
      // ✅ Otherwise, wait for the custom event
      document.addEventListener('google-maps-ready', handleGoogleMapsReady);
      return () => {
        document.removeEventListener('google-maps-ready', handleGoogleMapsReady);
      };
    }
  }, []);

  useEffect(() => {
    if (!mapReady || !mapRef.current) return;

    const map = new window.google.maps.Map(mapRef.current, {
      center: { lat: 34.20136, lng: -118.4522149 },
      zoom: 17,
      styles: [
        { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        { featureType: 'poi', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', stylers: [{ color: '#ffffff' }] },
        { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', stylers: [{ color: '#c9c9c9' }] },
        { 
          featureType: 'road.local', 
          elementType: 'labels.text.fill', 
          stylers: [{ visibility: 'on' }, { color: '#616161' }] 
        },
        { 
          featureType: 'road.local', 
          elementType: 'labels.text.stroke', 
          stylers: [{ visibility: 'on' }, { color: '#f5f5f5' }] 
        },
      ],
    });

    const bounds = new window.google.maps.LatLngBounds();

    locations.forEach(({ name, lat, lng, url }) => {
      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map,
        label: {
          text: name,
          color: '#000',
          fontFamily: "venice-blvd",
          fontWeight: 'bold',
          fontSize: '14px',
        },
        icon: {
          url: "https://afag.imgix.net/pablitos-tacos-van-nuys/chicken.png?w=500&auto=format",
          scaledSize: new window.google.maps.Size(80, 80),
          labelOrigin: new window.google.maps.Point(50, -10),
        },
        title: name,
      });

      marker.addListener('click', () => {
        // window.location.href = url;
      });

      bounds.extend(marker.getPosition());
    });

    // map.fitBounds(bounds);
  }, [mapReady]);

  return (
    <div style={{ width: '100%', height: '500px' }}>
      {mapReady ? (
        <div ref={mapRef} style={{ width: '100%', height: '100%', borderRadius: '16px' }} />
      ) : (
        <div style={{ width: '100%', height: '100%', background: '#eee', textAlign: 'center', paddingTop: '200px' }}>
          Loading map...
        </div>
      )}
    </div>
  );
};

export default RestaurantMap;